import { render, staticRenderFns } from "./studentRegistrations.vue?vue&type=template&id=24be8e63&scoped=true&"
import script from "./studentRegistrations.vue?vue&type=script&lang=js&"
export * from "./studentRegistrations.vue?vue&type=script&lang=js&"
import style0 from "./studentRegistrations.vue?vue&type=style&index=0&id=24be8e63&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24be8e63",
  null
  
)

export default component.exports